// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"597":"dbfc1c01","681":"6b2e14f8"}[chunkId] + ".chunk.css";
};